import {CALL_API} from 'middleware/api';

import * as ActionTypes from '../createPassword';

export function createPassword(data) {
    return {
        type: ActionTypes.CREATE_PASSWORD,
        [CALL_API]: {
            endpoint: `/api/passwd`,
            method: 'post',
            types: [ActionTypes.SUCCESS_CREATE_PASSWORD, ActionTypes.SUCCESS_CREATE_PASSWORD],
            credentials: true,
            data
        }
    };
}

export function initCreatePassword() {
    return {type: ActionTypes.INIT_CREATE_PASSWORD }
}


// WEBPACK FOOTER //
// ./js/actions/creators/createPassword.js